<template>
    <div>
        <h1 class="text-xl font-bold leading-tight tracking-tight md:text-2xl text-primary mb-4">
            {{ $t('Forgot your password') }}?
        </h1>
        <form class="grid gap-6 mb-6" @submit.prevent="submitForm">
            <div>
                <label for="email" class="block mb-2 text-sm font-medium text-gray-900">{{ $t('Your email') }}</label>
                <input v-model="formData.email" type="email" name="email" id="email"
                    class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                    placeholder="Enter your email" required />
                <small class="text-sm text-red-600 mt-1" v-if="msg['email']">{{ msg['email'] }}</small>
            </div>
            <div>
                <button type="submit"
                    class="w-full text-white bg-primary hover:bg-primary-700 focus:ring-4 focus:outline-hidden focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-3 text-center"
                    :disabled="loading">
                    <span v-if="loading">{{ $t('Sending') }}...</span>
                    <span v-else>{{ $t('Send password reset link') }}</span>
                </button>
            </div>
            <div>
                <p class="text-sm font-light text-gray-500">
                    {{ $t('Remembered your password') }}?
                    <a :href="loginUrl" class="font-medium text-primary-600 hover:underline">{{ $t('Login here') }}</a>
                </p>
            </div>
            <div v-if="msg['errorMessage']">
                <p class="text-sm text-red-600">{{ msg['errorMessage'] }}</p>
            </div>
            <div v-if="msg['successMessage']">
                <p class="text-sm text-green-600">{{ msg['successMessage'] }}</p>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            formData: {
                email: '',
            },
            msg: {},
            loading: false,
            loginUrl: "/login",
        };
    },
    methods: {
        async submitForm() {
            this.msg = {};
            if (!this.formData.email) {
                this.msg['email'] = this.$t('Email is required');
                return;
            }
            this.loading = true;
            try {
                const response = await fetch("/password/email", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRF-TOKEN": document
                            .querySelector('meta[name="csrf-token"]')
                            ?.getAttribute("content"),
                    },
                    body: JSON.stringify({ email: this.formData.email }),
                });

                if (!response.ok) {
                    let error = {};
                    try {
                        error = await response.json();
                    } catch (e) {
                        error = { message: this.$t("Failed to send reset link") };
                    }
                    this.msg['errorMessage'] =
                        error.message ||
                        (error.errors &&
                            Object.values(error.errors).flat().join(" ")) ||
                        this.$t("Failed to send reset link");
                } else {
                    this.msg['successMessage'] = this.$t("If your email address exists in our system, you will receive a password reset link shortly");
                    this.formData.email = '';
                }
            } catch (e) {
                this.msg['errorMessage'] = this.$t("Failed to send reset link");
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
